import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import { providerEventMappingService } from "../../utils/services/providerEventMappingService";
import ProviderEventMappingModal from "../../components/providerEventMappingModal";
import ProviderEventMappingList from "../../components/providerEventMappingList";

const ProviderEventMapping = () => {
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [mappingList, setMappingList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [searchValue, setSearchValue] = useState("");
  const [clientFilter, setClientFilter] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);

  const fetchEventMapping = async () => {
    setLoading(true);
    try {
      const response = await providerEventMappingService.fetch(
        rowsPerPage,
        page * rowsPerPage,
        clientFilter?._id,
        searchValue
      );
      setMappingList(response?.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEventMapping();
  }, [page, rowsPerPage, clientFilter, searchValue]);
  return (
    <>
      <DashboardContainer
        header={"Provider Event Mapping List"}
        hideUploadButton
        title={"+ Add Provider Event Mapping"}
        onClickAddButton={() => setOpenModal(true)}
        setViewMode={setViewMode}
        onSearchData={(x) => {
          if (x.trim()) {
            setSearchValue(x);
            setPage(0);
          } else {
            setSearchValue("");
          }
        }}
        hideFilterClient
        //eventMapping
      >
        <ProviderEventMappingModal
          selectedEventMapping={selectedMapping}
          handleClose={() => {
            setOpenModal(false);
            setSelectedMapping(null);
          }}
          open={openModal}
          onAddData={fetchEventMapping}
        />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <ProviderEventMappingList
            dataCount={dataCount}
            page={page}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchEventMapping}
            onEditData={(e) => {
              setSelectedMapping(e);
              setOpenModal(true);
            }}
            data={mappingList}
            viewMode={viewMode}
            selectedMapping={selectedMapping}
            setSelectedMapping={setSelectedMapping}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default ProviderEventMapping;
